<template>
  <div>
    <vm-table
        ref="vmTable"
        height="68vh"
        :filter.sync="filter"
        module="basic"
        url="applications/todo/my">
      <template slot="adSearch">
        <div class="vm-search">
          <el-radio-group v-model="filter.isread" style="margin-top: -20px;" @change="handleChange">
            <el-radio label="">全部</el-radio>
            <el-radio label="1">已读</el-radio>
            <el-radio label="0">未读</el-radio>
          </el-radio-group>
          <vm-search label="">
            <el-input v-model.trim="filter.filter" clearable/>
          </vm-search>
        </div>
      </template>
      <el-table-column
          prop="accessory"
          label=""
          :render-header="renderHeader1"
          width="50"
          align="center">
        <template slot-scope="scope">
          <span v-if="scope.row.accessory === '1'">
            <i class="el-icon-paperclip"/>
          </span>
        </template>
      </el-table-column>
      <el-table-column
          prop="read"
          label=""
          :render-header="renderHeader2"
          width="50"
          align="center">
        <template slot-scope="scope">
          <span v-if="scope.row.read === '0'">
            <i class="el-icon-message"/>
          </span>
        </template>
      </el-table-column>
      <el-table-column
          prop="untreadedTimes"
          label=""
          :render-header="renderHeader3"
          width="50"
          align="center">
        <template slot-scope="scope">
          <span v-if="scope.row.untreadedTimes > 0">
            <i class="el-icon-refresh-left"/>
          </span>
        </template>
      </el-table-column>
      <!--      <el-table-column prop="sequID" label="主键" width="80"/>-->
      <el-table-column prop="billNO" label="对账单号" width="100">
        <template slot-scope="scope">
          <a @click="gotoApprove(scope.row)">{{scope.row.billNO}}</a>
        </template>
      </el-table-column>
      <el-table-column align="center" prop="billType" width="90" label="对账类型">
        <template v-slot="scope">
          <span v-if="scope.row.billType === 10">整单对账</span>
          <span v-if="scope.row.billType === 20">拆单对账</span>
        </template>
      </el-table-column>
      <el-table-column
          prop="supplierName"
          align="center"
          label="供应商名称"
          min-width="150"
          show-overflow-tooltip/>
      <el-table-column
          prop="buyUserName"
          align="center"
          label="采购组"
          min-width="80"
          show-overflow-tooltip/>
      <el-table-column
          prop="invoiceType"
          align="center"
          label="发票类型"
          min-width="80"
          show-overflow-tooltip/>
      <el-table-column
          prop="invoiceNo"
          align="center"
          label="发票号码"
          min-width="100"
          show-overflow-tooltip/>
      <el-table-column
          prop="creatorName"
          align="center"
          label="创建人"
          min-width="70"
          show-overflow-tooltip/>
      <el-table-column prop="submitDate" label="提交时间" width="140"/>
      <el-table-column prop="descrpt" label="节点名称" width="120"/>
      <el-table-column prop="createdTime" label="上节点处理时间" width="140"/>
    </vm-table>
  </div>
</template>
<script>
  import VmTable from "@/components/VmTable.vue";
  import VmSearch from "@/components/VmSearch.vue";

  export default {
    // name: "ReconcileOrder",
    components: {VmTable, VmSearch},
    data() {
      return {
        filter: {
          billType: 27,
          isread: "",
          filter: "",
        },
      };
    },
    mounted() {
      this.getList(1);
    },
    methods: {
      getList(pageNum) {
        this.$refs.vmTable.getList(pageNum);
      },
      handleChange() {
        this.getList(1);
      },
      gotoApprove(row) {
        this.$router.push({
          path: "/approval",
          query: {
            billType: 27,
            billId: row.billID,
            sequId: row.sequID,
            $tabName: "审批_" + row.billNO,
          },
        });
      },
      renderHeader1(h,{column}) {
        return h(
          "span",
          [
            h("span", column.label),
            h("i", {
              class:"el-icon-paperclip",
              style:"color:#444444; font-size: 16px;",
            }),
          ],
        );
      },
      renderHeader2(h,{column}) {
        return h(
          "span",
          [
            h("span", column.label),
            h("i", {
              class:"el-icon-message",
              style:"color:#444444; font-size: 16px;",
            }),
          ],
        );
      },
      renderHeader3(h,{column}) {
        return h(
          "span",
          [
            h("span", column.label),
            h("i", {
              class:"el-icon-refresh-left",
              style:"color:#444444; font-size: 16px;",
            }),
          ],
        );
      },
    },
  };
</script>
<style lang="scss" scoped>
</style>
